import React from "react"
import { useDispatch } from "react-redux"
import cn from "classnames"
import { useTranslation } from "react-i18next"
import { actions } from "@/signomatic/store/actions"
import type Sign from "@/signomatic/app/sign"
import RowButton from "@/signomatic/components/row_button"
import SidesIcon from "@/skylticons/handle_sides"
import tailwindTheme from "@/common/styles/theme.module.css"
import useMedia from "@/common/hooks/use_media"
import { CopyOutline } from "@/skylticons"

interface DoubleSidedControlsProps {
  sign: Sign
  signState: SignState | null
  showLabel?: boolean
  buttonClasses?: string
}

const DoubleSidedControls: React.FC<DoubleSidedControlsProps> = ({ signState, sign, showLabel, buttonClasses }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const desktop = useMedia(`(min-width: ${tailwindTheme.screensLg})`)
  const mobileXs = useMedia(`(max-width: ${tailwindTheme.screensXs})`)

  if (!signState) {
    return null
  }

  return (
    <div className="doublesided-controls">
      {!desktop && (
        <RowButton
          onClick={() => dispatch(actions.setToolbox("sides"))}
          className={cn(buttonClasses, { "icon-only": mobileXs || !!showLabel })}
        >
          <SidesIcon className={cn({ "!mr-0": mobileXs || !!showLabel })} />
          {(!mobileXs || showLabel) && <span>{t("toolbox.sides")}</span>}
        </RowButton>
      )}
      {desktop && (
        <div className="side-switcher">
          <div>
            <label className="paragraph-xs bold mb-0">{t("toolbox.side")}</label>
          </div>
          <div className="sides" onClick={() => (signState.side === 0 ? sign.setSide(1) : sign.setSide(0))}>
            <div className={cn("side", "a", { active: signState.side === 0 })}>
              <div className="letter">A</div>
            </div>
            <div className={cn("side", "b", { active: signState.side === 1 })}>
              <div className="letter">B</div>
            </div>
          </div>
          <RowButton className="side-copy" onClick={() => sign.copySide()}>
            <CopyOutline />
            <span>{t("toolbox.copy_side")}</span>
          </RowButton>
        </div>
      )}
    </div>
  )
}

export default DoubleSidedControls
